import cmpBtnFacebookLogin from '../vue/common/FacebookLoginButton.vue';
import cmpBtnGoogleLogin from '../vue/common/GoogleLoginButton.vue';
import cmpFormSignIn from '../vue/common/SignInForm.vue';

window.FacebookLoginButton = (function(){
	const component = Vue.createApp(cmpBtnFacebookLogin, {
		appId: window.FbAppId,
		version: window.FbVersion,
		urlRedirect: '/templates/',
		width: 300
	});
	delete window.FbAppId;
	delete window.FbVersion;
	return component.mount('#component-button-facebook-login');
})();

window.GoogleLoginButton = (function(){
	const component = Vue.createApp(cmpBtnGoogleLogin, {
		clientId: window.GClientId,
		redirectUrl: '/templates/',
		width: 300
	});
	delete window.GClientId;
	return component.mount('#component-button-google-login');

})();

window.SignInForm = (function(){
	var showLogin = (window?.ShowLogin ?? true) ? 'true' : 'false';
	const component = Vue.createApp(cmpFormSignIn, {
		redirectUrl: '/templates/',
		showLogin: showLogin,
		width: 300
	});
	delete window.ShowLogin;
	return component.mount('#component-form-signin');
})();
